import { AfterViewInit, Component, OnDestroy } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { NavigationMenuService } from "../shared/services/navigation-menu/navigation-menu.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-settings",
  templateUrl: "./settings.component.html",
  styleUrls: ["./settings.component.scss"],
  standalone: false
})
export class SettingsComponent implements OnDestroy, AfterViewInit {
  private onDestroy$ = new Subject();
  public isLeftbarOpen: boolean = false;

  public constructor(
    private navigationMenuService: NavigationMenuService,
    private router: Router
  ) {}

  shouldShowSettingsMenu() {
    return (
      this.router.url.includes("/mark") ||
      this.router.url.includes("/title") ||
      this.router.url.includes("/tags") ||
      this.router.url.includes("/tenant-config")
    );
  }

  ngAfterViewInit() {
    this.navigationMenuService.leftBarState$.pipe(takeUntil(this.onDestroy$)).subscribe((isLeftbarOpen) => {
      this.isLeftbarOpen = isLeftbarOpen;
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.unsubscribe();
  }
}
